import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import swal from 'sweetalert'
import useLocalization from 'hooks/useLocalization'
import { superAxiosRequestEasy } from 'axiosApi'
import Stores from 'Stores'
import { classNames as cn } from 'helpers'
import CompanyLogo from '../Common/CompanyLogo'
import InputInn from '../SignUp/InputInn/InputInn'
import SelectCustom from '../../../ContentBox/Global/Select/SelectCustom'
import SexSelector from '../SignUp/SexSelector/SexSelector'
import AuthFooter from '../Common/AuthFooter'
import stWrapperAuth from 'components/Wrappers/WrapperAuth.module.scss'
import stSignUp from '../SignUp/SignUp.module.scss'
import st from './AddBook.module.scss'
import srcStudying1 from '../img/shutterstock_2350780611.svg'
import { ReactComponent as EyeLine } from '../img/eye-line.svg'
import { ReactComponent as EyeOffLine } from '../img/eye-off-line.svg'
import Checkbox from 'components/ContentBox/Global/Checkbox/Checkbox'

const passwordText = [
  {
    content: 'Consist of at least 8 characters',
    key: 'minSymbol',
    localization: 'pass_min_symbol',
  },
  {
    content: 'Contain at least 1 letter (a, b, c...)',
    key: 'minLetters',
    localization: 'pass_min_letters',
  },
  {
    content: 'Contain at least 1 digit (1, 2, 3...)',
    key: 'minNumbers',
    localization: 'pass_min_numbers',
  },
]

const hasCyrillicCharacters = (inputString) => /[а-яА-ЯЁё]+/.test(inputString)

const isPunycodeEncoded = (str) => /xn--[0-9a-z-]+/i.test(str)

const AddBook = () => {
  const { uuid } = useParams()

  const [user, setUser] = useState({
    first_name: '',
    last_name: '',
    inn: '',
    sex: 'M',
    password: '',
    email: '',
    country: 'kz',
    user_exists: false,
  })

  const countryOptions = [
    { id: 'kz', name: 'Kazakhstan' },
    { id: 'kr', name: 'Kyrgyzstan' },
    { id: 'uz', name: 'Uzbekistan' },
    { id: 'ru', name: 'Russia' },
    { id: 'br', name: 'Belarus' },
  ]

  const changeValues = (value, fieldName) => {
    setUser((prevState) => ({ ...prevState, [fieldName]: value }))
  }

  const [innTypeID, setInnTypeID] = useState(1)
  const [validPassword, setValidPassword] = useState({
    minSymbol: false,
    minLetters: false,
    minNumbers: false,
  })
  const [errors, setErrors] = useState([])
  const [showPassword, setShowPassword] = useState(false)
  const [book, setBook] = useState(null)
  const [isDisabled, setIsDisabled] = useState(false)
  const { translate } = useLocalization({
    section: 'user',
    subsection: 'sign_up',
  })

  const innOptions = [
    { id: 1, name: translate.iin },
    { id: 2, name: translate.inn },
  ]

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked
    setIsDisabled(isChecked)
    setUser((prevUser) => ({ ...prevUser, user_exists: isChecked }))
  }

  const submitHandler = () => {
    const emptyFields = Object.keys(user).filter(
      (key) => !isDisabled && user[key] === '',
    )
    const checkPassword = Object.values(validPassword)
    setErrors(emptyFields)

    const payload = isDisabled
      ? {
          email: user.email,
          password: user.password,
          user_exists: user.user_exists,
        }
      : user

    if (checkPassword.includes(false)) {
      setErrors([...emptyFields, 'password'])
    }
    if (emptyFields.length === 0 && !checkPassword.includes(false)) {
      const { inn, email } = user

      if ((!isDisabled && inn.length < 12) || isNaN(+inn)) {
        swal({
          text: `Вы ввели неверный ${innTypeID === 1 ? 'ИИН' : 'ИНН'}`,
          icon: 'warning',
        }).then(() => {})
      } else if (
        hasCyrillicCharacters(email) ||
        isPunycodeEncoded(user.email)
      ) {
        swal({
          text: 'Вы ввели неверный email',
          icon: 'warning',
        }).then(() => {})
      } else {
        superAxiosRequestEasy(
          {
            method: 'post',
            link: 'accounts/register_client_book/' + uuid,
          },
          payload,
        )
          .then(() => {
            if (isDisabled) {
              swal({
                text: `Книга успешно добавлена`,
                icon: 'success',
              }).then((result) => {
                if (result) {
                  window.location.href = '/'
                }
              })
            } else {
              swal({
                text: `На вашу электронную почту ${email} было отправлено письмо с подтверждением регистрации.
              Пожалуйста зайдите в электронную почту и нажмите на ссылку в письме для завершения регистрации.`,
                icon: 'success',
              }).then((result) => {
                if (result) {
                  window.location.href = '/'
                }
              })
            }
          })
          .catch(({ response }) => {
            if (response?.data?.non_field_errors) {
              swal({
                text: 'Вы ввели неверный ИИН',
                icon: 'warning',
              }).then(() => {})
            } else if (response?.data?.email) {
              swal({
                text: response.data.email[0],
                icon: 'warning',
              }).then(() => {})
            } else if (response?.data?.phone) {
              swal({
                text: response.data.phone[0],
                icon: 'error',
              }).then(() => {})
            } else {
              swal({
                text: 'Произошла ошибка',
                icon: 'error',
              }).then(() => {})
            }
          })
      }
    }
  }

  useEffect(() => {
    superAxiosRequestEasy({
      method: 'get',
      link: `ebooks/books_info/${uuid}`,
    })
      .then((res) => {
        setBook(res.data)
      })
      .catch(() => {})
  }, [uuid])

  useEffect(() => {
    const { password } = user
    setErrors([])
    setValidPassword({
      minSymbol: password.length >= 8,
      minLetters: /(?=.*[a-z])/.test(password),
      minNumbers: /(?=.*\d)/.test(password),
    })
  }, [user])

  return (
    <>
      <article className={stWrapperAuth.content}>
        <div className={stWrapperAuth.authBox}>
          {/*<CompanyLogo/>*/}

          <h1 className={stWrapperAuth.heading1}>
            Add Book{' '}
            <span role='img' aria-label='Add Book'>
              &#128214;
            </span>
          </h1>

          <div className={st.book}>
            <div className={st.bookText}>
              Register a new book in your personal account
            </div>
            {book && (
              <img
                src={Stores.baseLink() + book.image}
                alt=''
                className={st.bookImage}
              />
            )}
          </div>

          <div className={`${stWrapperAuth.form} ${stSignUp.formSignUp}`}>
            <div className={stWrapperAuth.field}>
              <div className={stWrapperAuth.labelRequired}>
                {translate.name}:
              </div>
              <input
                type='text'
                disabled={isDisabled}
                value={user.first_name}
                onChange={(e) => {
                  setUser({ ...user, first_name: e.target.value })
                }}
                className={cn({
                  [stWrapperAuth.input]: true,
                  [stWrapperAuth.inputError]: errors.includes('first_name'),
                })}
              />
            </div>

            <div className={stWrapperAuth.field}>
              <div className={stWrapperAuth.labelRequired}>
                {translate.surname}:
              </div>
              <input
                type='text'
                value={user.last_name}
                disabled={isDisabled}
                onChange={(e) => {
                  setUser({ ...user, last_name: e.target.value })
                }}
                className={cn({
                  [stWrapperAuth.input]: true,
                  [stWrapperAuth.inputError]: errors.includes('last_name'),
                })}
              />
            </div>

            <div className={stWrapperAuth.field}>
              <div className={stWrapperAuth.labelRequired}>Country:</div>
              <div>
                <SelectCustom
                  placeholder='Select your country'
                  options={countryOptions.map((country) => ({
                    value: country.id,
                    label: country.name,
                  }))}
                  valueID={user.country}
                  onChange={(o) => changeValues(o.value, 'country')}
                  error={errors.includes('country')}
                  isDisabled={isDisabled}
                />
              </div>
            </div>

            <div className={stWrapperAuth.field}>
              <div className={stWrapperAuth.labelRequired}>
                {translate.iin} / {translate.inn}:
              </div>
              <InputInn
                options={innOptions}
                onChange={(val) => setUser({ ...user, inn: val })}
                value={`${user.inn}`}
                onChangeType={(obj) => setInnTypeID(obj.id)}
                error={errors.includes('inn')}
                disabled={isDisabled}
              />
            </div>

            <div className={stWrapperAuth.field}>
              <div className={stWrapperAuth.labelRequired}>
                {translate.sex}:
              </div>
              <div>
                <SexSelector
                  options={[
                    { id: 'M', name: translate.male },
                    { id: 'F', name: translate.female },
                  ]}
                  value={user.sex}
                  onChange={(val) => setUser({ ...user, sex: val })}
                />
              </div>
            </div>

            <div className={stWrapperAuth.field}>
              <div className={stWrapperAuth.labelRequired}>
                {translate.email}:
              </div>
              <input
                type='email'
                value={user.email}
                onChange={(e) => {
                  setUser({ ...user, email: e.target.value })
                }}
                className={cn({
                  [stWrapperAuth.input]: true,
                  [stWrapperAuth.inputError]: errors.includes('email'),
                })}
              />
            </div>

            <div className={stWrapperAuth.field}>
              <div className={stWrapperAuth.labelRequired}>
                {translate.password}:
              </div>
              <div className={stSignUp.inputPassword}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={user.password}
                  onChange={(e) => {
                    setUser({ ...user, password: e.target.value.trim() })
                  }}
                  className={cn({
                    [stWrapperAuth.input]: true,
                    [stWrapperAuth.inputError]: errors.includes('password'),
                  })}
                />
                {showPassword ? (
                  <EyeLine onClick={() => setShowPassword(!showPassword)} />
                ) : (
                  <EyeOffLine onClick={() => setShowPassword(!showPassword)} />
                )}
              </div>
              <div>
                {passwordText.map((item) => (
                  <p
                    key={item.key}
                    className={cn({
                      [stSignUp.checkPasswordItemCorrect]:
                        validPassword[item.key],
                      [stSignUp.checkPasswordItem]: true,
                    })}
                  >
                    {translate[item.localization] || item.content}
                  </p>
                ))}
              </div>
            </div>

            <div className={stWrapperAuth.submit}>
              <div onClick={submitHandler}>
                <button>Add book</button>
              </div>
              <div className={stWrapperAuth.haveAccount}>
                <p>{translate.have_account}?</p>
                <Checkbox
                  onChange={(checked) =>
                    handleCheckboxChange({ target: { checked } })
                  }
                  checked={user.user_exists}
                />
              </div>
            </div>
          </div>
        </div>
      </article>
      <AuthFooter srcPromo={srcStudying1} />
    </>
  )
}

export default AddBook
